export const education = [
  {
    id: 1,
    institution: 'University of Toronto',
    degree: 'Bachelor of Science in Computer Science, Cognitive Science, and Mathematics',
    location: 'Toronto, Ontario',
    duration: '2021 - 2025',
    gpa: '3.8/4.0',
    description:
      'Focused on machine learning, software systems, and cognitive modeling through interdisciplinary coursework and applied projects.',
    achievements: [
      'Built research-driven machine learning and cognitive modeling projects.',
      'Applied software engineering practices across full-stack and AI-integrated products.',
      'Presented technical work in academic and industry-facing settings.'
    ],
    relevantCourses: [
      'Data Structures & Algorithms',
      'Software Engineering',
      'Database Systems',
      'Machine Learning',
      'Computer Networks',
      'Operating Systems'
    ]
  }
];
